import type { SpartenStatusResponse } from '@/features/Global/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class GlobalHttpService extends HttpService {
  loadSpartenStatus(): HttpClientResponse<SpartenStatusResponse> {
    return this.httpClient.get('productstatus');
  }
}
